"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _identity = _interopRequireDefault(require("lodash/identity"));
var _Box = _interopRequireDefault(require("../Containers/Box"));
var _ErrorFallbackCommon = _interopRequireDefault(require("./ErrorFallbackCommon"));
var _Modal = _interopRequireDefault(require("../Modals/Modal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var propTypes = {
  error: _propTypes["default"].object,
  resetErrorBoundary: _propTypes["default"].func
};
var ErrorFallbackModal = function ErrorFallbackModal(props) {
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: true,
    shouldCloseOnOverlayClick: false,
    withCloseButton: false,
    w: "400px",
    verticalPosition: "center",
    onRequestClose: _identity["default"],
    p: "none"
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    d: "flex",
    direction: "column",
    alignItems: "center",
    justifyContent: "center",
    w: "100%",
    p: "base"
  }, /*#__PURE__*/_react["default"].createElement(_ErrorFallbackCommon["default"], props)));
};
ErrorFallbackModal.propTypes = propTypes;
ErrorFallbackModal.displayName = "Error_Fallback_Modal_Component";
var _default = ErrorFallbackModal;
exports["default"] = _default;